import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'check'
})
export class CheckPipe implements PipeTransform {

  /**
   * this pipe can be used with *ngIf, to check if fn(data) holds true
   * @param data any data
   * @param fn check function
   */
  transform(data: any, fn: (data: any) => boolean): boolean {
    return data && fn ? fn(data) : true;
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/pipes/check.pipe.ts